// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

type EditProps = {
  title?: string;
};

export function Edit({ title = 'Edit' }: EditProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      role="img"
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 7.68747L16.3125 4L5.22972 15.0828L8.9172 18.7702L20 7.68747ZM4.68095 15.6316L3.99997 20.0001L8.36843 19.3191L4.68095 15.6316Z"
        fill="currentColor"
      />
    </svg>
  );
}
